module.exports = __webpack_public_path__ + "img/Frame-92.fb26dd4c.svg";